import Vue from 'vue'
import {$notes} from '@/services/'

const module = {
  namespaced: true,

  state: {
    items: [],
    item: {},
    meta: { pagination: {}},
    shapes: []
  },

  getters: {
    items: state => state.items,
    item: state => state.item,
    meta: state => state.meta,
    shapes: state => state.shapes
  },

  mutations: {
    ITEMS(state, value){
      value = value.map( (item) =>{
        item.asset_status = (item.asset && item.asset.status) || "Pending"
        return item
      })
      state.items = value
    },

    ITEM(state,value){
      state.item = value
    },

    ADD_ITEM(state, value){
      state.items.push(value)
    },

    META(state, meta){
      state.meta = meta
    },

    UPDATE(state, {id, data}){
      var index = state.items.findIndex(obj => obj.id == id)
      index > -1 && Vue.set(state.items, index, data)
      if(state.item.id == id){
        state.item = {...state.item, ...data}
      }
    },
    
    DELETE(state, id){
      let index = state.items.findIndex(i => i.id == id)
      index > -1 && state.items.splice(index,1)
    },

    ADD_SHAPE(state, shape){
    	state.shapes.push(shape)
    }
  },

  actions: {
    all({ commit }, { projectId, config }){
      return $notes._(projectId).all(config)
        .then(function(res){
          let {data, meta} = res.data
          commit('ITEMS', data)
          commit('META', meta)
          return res
        })
    },

    create({ commit }, { projectId, payload, config }){
      return $notes._(projectId).create(payload, config)
      .then(res => {
        commit('ADD_ITEM', res.data.data)
        return res
      })
    },

    find({ commit }, { projectId, id, config }){
      return $notes._(projectId).show(id, config)
      .then(res => {
        commit('ITEM', res.data.data)
        return res
      })
    },

    delete({commit}, {projectId, id}){
      return $notes._(projectId).delete(id)
      .then(() => {
        commit('DELETE', id)
      })
    },

    update({commit}, {projectId, id, payload, config}){
      console.log('note update')
      return $notes._(projectId).update(id, payload, config).then(res => {
        let { data }= res.data
        commit('UPDATE', {id, data})
        return res
      })
    },

    addShape({commit}, {shape}){
    	commit('ADD_SHAPE', shape)
    }
  }
}

export default module
